import styles from "./ImpactBannerSection.module.css";

type ImpactBannerSectionProps = {
  imageSrc: string;
};

function ImpactBannerSection({ imageSrc }: ImpactBannerSectionProps) {
  return (
    <section className={styles.section} aria-label="Nature economy impact">
      <div className={styles.container}>
        <div className={styles.banner}>
          <img
            className={styles.image}
            src={imageSrc}
            alt=""
            aria-hidden="true"
          />
          <div className={styles.overlay} aria-hidden="true" />
          <p className={styles.copy}>
            OVER 50% OF GLOBAL GDP
            <br />
            (THAT&apos;S £32 TRILLION)
            <br />
            DEPENDS ON NATURE.
          </p>
        </div>
      </div>
    </section>
  );
}

export default ImpactBannerSection;
